import { Characteristic } from '@/services/models/Characteristic'
import { Characteristics, CharacteristicType, ProductStatus, SalesPackageType } from '@/helper/Types'
import { ProductResponse } from '@/services/models/ProductResponse'

export class Product implements ProductResponse {
  public id = ''
  public name = ''
  public marketingName = ''
  public normalizedMarketingName = ''
  public orderNumber = ''
  public pictureUrl = ''
  public price = 0
  public updatedPrice = 0
  public productAdvantages: string[] = []
  public recommended?: boolean
  public status?: ProductStatus
  public characteristics: Characteristics[] = []
  public inSalePackage = false
  public salesPackageType?: SalesPackageType

  public constructor(productData?: Partial<Product>) {
    Object.assign(this, productData)
  }

  public getProductCharacteristic<T extends Characteristic>(type: CharacteristicType): T {
    return this.characteristics.find(chr => chr.type === type) as T
  }
}
